module.exports = __webpack_public_path__ + "img/aboutUs-zqp.74e5e535.png";